<template>
  <el-form ref="form" label-width="80px">
    <el-form-item label="组件名称">
      <el-input v-model="curItem.fieldName" :maxlength="10" show-word-limit></el-input>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="curItem.isRequired"></el-switch>
    </el-form-item>
    <!-- <el-form-item label="校验提示" v-if="curItem.isRequired">
      <el-input v-model="curItem.tips"></el-input>
    </el-form-item> -->
    <el-form-item label="是否表头">
      <el-switch v-model="curItem.isTableHead"></el-switch>
    </el-form-item>
    <el-form-item label="可搜索">
      <el-switch v-model="curItem.isSearch" @change="changeSearch"></el-switch>
    </el-form-item>
    <!-- 文本输入框 -->
    <template v-if="curItem.fieldType === 1 || curItem.fieldType === 2">
      <el-form-item label="占位提示">
        <el-input
          v-model="curItem.extar['placeholder']"
          :maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="字数限制">
        <el-input-number v-model="curItem.extar['maxlength']" :min="50" :precision="0"></el-input-number>
      </el-form-item> -->
    </template>
    <!-- 数字输入框 -->
    <template v-else-if="curItem.fieldType === 3">
      <el-form-item label="保留小数">
        <el-input-number v-model="curItem.extar['precision']"></el-input-number>
      </el-form-item>
    </template>
    <!-- 单选 多选 -->
    <template v-else-if="curItem.fieldType >= 4 && curItem.fieldType <= 7">
      <el-form-item label="选项">
        <div v-for="(opt, i) in curItem.selectTypes" :key="i" class="options">
          <el-input
            v-model="curItem.selectTypes[i]"
            :maxlength="10"
            show-word-limit
            style="margin-right: 10px"
          ></el-input>
          <el-button
            icon="el-icon-remove-outline"
            circle
            @click="deleteOption(i)"
          ></el-button>
          <el-button
            icon="el-icon-top"
            circle
            @click="moveupOption(i)"
          ></el-button>
          <el-button
            icon="el-icon-bottom"
            circle
            @click="movedownOption(i)"
          ></el-button>
        </div>
        <el-button type="primary" @click="addOption">增加选项</el-button>
      </el-form-item>
    </template>
    <!-- 文件上传 -->
    <template v-else-if="curItem.fieldType === 10">
      <el-form-item label="上传类型">
        <el-checkbox-group v-model="curItem.fileTypes">
          <el-checkbox label="pdf"></el-checkbox>
          <el-checkbox label="png"></el-checkbox>
          <el-checkbox label="jpg"></el-checkbox>
          <el-checkbox label="excel"></el-checkbox>
          <el-checkbox label="word"></el-checkbox>
          <el-checkbox label="ppt"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
export default {
  name: "EditRule",
  props: ["curItem"],
  data() {
    return {
    }
  },
  methods: {
    // 设置可搜索 自动设置表头
    changeSearch(val) {
      if (val) {
        this.curItem.isTableHead = true;
      }
    },
    // 增加选项
    addOption() {
      const len = this.curItem["selectTypes"].length;
      this.curItem["selectTypes"].push(`选项${len + 1}`);
    },
    // 删除选项
    deleteOption(index) {
      const len = this.curItem["selectTypes"].length;
      if (len === 1) {
        this.$notify.warning("最少保留一个选项");
        return;
      }
      this.curItem["selectTypes"].splice(index, 1);
    },
    // 上移选项
    moveupOption(index) {
      if (index === 0) return;
      const option1 = this.curItem["selectTypes"][index];
      const option2 = this.curItem["selectTypes"][index - 1];
      this.curItem["selectTypes"].splice(index, 1, option2);
      this.curItem["selectTypes"].splice(index - 1, 1, option1);
    },
    // 下移选项
    movedownOption(index) {
      const len = this.curItem["selectTypes"].length;
      if (index === len - 1) return;
      const option1 = this.curItem["selectTypes"][index];
      const option2 = this.curItem["selectTypes"][index + 1];
      this.curItem["selectTypes"].splice(index, 1, option2);
      this.curItem["selectTypes"].splice(index + 1, 1, option1);
    }
  }
}
</script>

<style lang="less" scoped>
.options {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
</style>